import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const Hero = () => {
  const { t } = useLang();
  return (
    <section className="grain relative overflow-hidden" data-testid="hero-section">
      <div className="pointer-events-none absolute -left-40 top-10 h-[520px] w-[520px] rounded-full bg-smoke/30 blur-[120px]" />
      <div className="pointer-events-none absolute -right-20 bottom-0 h-[420px] w-[420px] rounded-full bg-ruby/25 blur-[120px]" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-5 pb-20 pt-14 lg:grid-cols-[1.15fr_1fr] lg:px-8 lg:pb-28 lg:pt-20">
        <div>
          <p className="eyebrow rise">{t("hero.eyebrow")}</p>
          <h1 className="mt-5 font-display text-5xl leading-[0.95] sm:text-6xl lg:text-7xl">
            <span className="rise block" style={{ animationDelay: "80ms" }}>{t("hero.title1")}</span>
            <span className="rise block text-gold-grad" style={{ animationDelay: "160ms" }}>{t("hero.title2")}</span>
            <span className="rise block" style={{ animationDelay: "240ms" }}>{t("hero.title3")}</span>
          </h1>
          <p className="rise mt-7 max-w-xl text-base text-slate-300 md:text-lg" style={{ animationDelay: "320ms" }}>
            {t("hero.sub")}
          </p>
          <div className="rise mt-9 flex flex-wrap gap-4" style={{ animationDelay: "400ms" }}>
            <Link to="/order" className="btn-gold" data-testid="hero-start-order-btn">
              {t("hero.cta")} <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/#pricing" className="btn-ghost" data-testid="hero-pricing-btn">
              {t("hero.cta2")}
            </Link>
          </div>
          <ul className="rise mt-10 flex flex-wrap gap-x-6 gap-y-2 text-sm font-bold text-slate-300" style={{ animationDelay: "480ms" }}>
            {["b1", "b2", "b3"].map((b) => (
              <li key={b} className="flex items-center gap-2">
                <Check className="h-4 w-4 text-gold" /> {t(`hero.${b}`)}
              </li>
            ))}
          </ul>
        </div>
        <div className="relative mx-auto w-full max-w-md lg:max-w-lg">
          <div className="absolute inset-6 rotate-6 rounded-xl border-2 border-dashed border-gold/30" />
          <div className="absolute inset-10 -rotate-3 rounded-xl bg-panel2/60" />
          <img src="/brand/logo.png" alt="MC Illusions Prints" className="floaty relative z-10 w-full drop-shadow-[0_30px_40px_rgba(0,0,0,0.55)]" data-testid="hero-logo" />
          <span className="absolute -left-2 top-8 z-20 -rotate-6 rounded bg-ruby px-3 py-1 text-xs font-extrabold uppercase tracking-wider shadow-lg">DTF</span>
          <span className="absolute -right-1 bottom-16 z-20 rotate-6 rounded bg-cap px-3 py-1 text-xs font-extrabold uppercase tracking-wider shadow-lg">UV DTF</span>
        </div>
      </div>
    </section>
  );
};
